<header class="shell-bar" *ngIf="visible">
  <div class="shell-left">
    <button type="button" class="icon-btn" *ngIf="sidenavToggle.visible"
            [attr.aria-label]="sidenavToggle.open ? 'Hide options panel' : 'Show options panel'"
            [attr.aria-expanded]="sidenavToggle.open"
            (click)="onToggleSidenav()">
      <mat-icon aria-hidden="true">{{ sidenavToggle.open ? 'menu_open' : 'menu' }}</mat-icon>
    </button>

    <nav class="crumbs" aria-label="Breadcrumb">
      <ol>
        <li class="crumb-ellipsis" *ngIf="crumbs.length > 2" aria-hidden="true">…</li>
        <li *ngFor="let crumb of crumbs; let last = last; trackBy: trackByCrumb"
            class="crumb"
            [class.crumb--home]="crumb.icon"
            [class.crumb--shrink]="crumb.shrinks"
            [class.crumb--narrow-hidden]="crumb.narrowHidden"
            [attr.aria-current]="last ? 'page' : null">
          <a *ngIf="crumb.url; else plainCrumb" [class.crumb-icon]="crumb.icon" [attr.href]="crumb.url" (click)="onNavigate($event, crumb.url)">
            <ng-container *ngTemplateOutlet="crumbBody; context: { $implicit: crumb }"></ng-container>
          </a>
          <ng-template #plainCrumb>
            <span [class.crumb-icon]="crumb.icon">
              <ng-container *ngTemplateOutlet="crumbBody; context: { $implicit: crumb }"></ng-container>
            </span>
          </ng-template>
        </li>
      </ol>
    </nav>
  </div>

  <ng-template #crumbBody let-crumb>
    <ng-container *ngIf="crumb.icon; else crumbText">
      <mat-icon aria-hidden="true">{{ crumb.icon }}</mat-icon>
      <span class="sr-only">{{ crumb.label }}</span>
    </ng-container>
    <ng-template #crumbText>{{ crumb.label }}</ng-template>
  </ng-template>

  <div class="brand-centre">
    <a class="brand" [attr.href]="centreLogoIsLine ? '/home' : '/mode'"
       [attr.aria-label]="centreLogoAlt"
       (click)="onNavigate($event, centreLogoIsLine ? '/home' : '/mode')">
      <img class="brand-logo" [class.brand-logo--line]="centreLogoIsLine" [src]="centreLogo" alt="">
    </a>
  </div>

  <div class="shell-right">
    <button #accountButton type="button" class="account-btn"
            aria-label="Account menu" aria-haspopup="menu" [attr.aria-expanded]="menuOpen"
            (click)="toggleMenu()">
      <span class="avatar" aria-hidden="true">{{ userInitial }}</span>
      <span class="account-name">{{ userName }}</span>
      <mat-icon class="chevron" aria-hidden="true">expand_more</mat-icon>
    </button>

    <div class="user-menu" *ngIf="menuOpen" role="menu" aria-label="Account">
      <div class="um-head">
        <span class="avatar avatar--lg" aria-hidden="true">{{ userInitial }}</span>
        <div class="um-identity">
          <p class="um-name">{{ userName }}</p>
          <p class="um-meta" *ngIf="userMeta">{{ userMeta }}</p>
        </div>
      </div>

      <p class="um-eyebrow">My projects</p>
      <p class="um-note" *ngIf="projectsLoading">Loading…</p>
      <p class="um-note" *ngIf="projectsError">Could not load your projects.</p>
      <p class="um-note" *ngIf="!projectsLoading && !projectsError && projects.length === 0">No projects yet.</p>
      <ul class="um-projects" *ngIf="projects.length">
        <li *ngFor="let project of projects; trackBy: trackByProject">
          <button type="button" role="menuitem" class="um-project" (click)="onResume(project)">
            <span class="um-project-name">{{ project.name }}</span>
            <span class="um-project-meta">{{ project.metaLabel }}</span>
          </button>
        </li>
      </ul>

      <div class="um-sep" role="separator"></div>
      <button type="button" role="menuitem" class="um-item" (click)="onAllProjects()">All projects</button>
      <button type="button" role="menuitem" class="um-item um-item--danger" (click)="onLogout()">Log out</button>
    </div>
  </div>
</header>
